const paipan = {
  'page.title': '八字排盤',
  'page.lunarLabel': '農曆：',
  'page.solarLabel': '陽曆：',
  'page.menu.edit': '修改命主資料',
  'page.menu.switchProfile': '切換命主',
  'page.menu.share': '分享命盤',
  'page.menu.export': '匯出PDF',
  'page.menu.save': '收藏命盤',
  'page.menu.saved': '已收藏',
  'page.menu.ruleSettings': '規則設定',
  'page.menu.delete': '刪除命盤',
  'page.tab.basic': '基本資訊',
  'page.tab.paipan': '基本排盤',
  'page.tab.professional': '專業排盤',
  'page.tab.pro': '排盤詳析',
  'page.relation.self': '本人',
  'page.relation.lover': '戀人',
  'page.relation.partner': '伴侶',
  'page.relation.child': '子女',
  'page.relation.parent': '父母',
  'page.relation.friend': '朋友',
  'page.relation.colleague': '同事',
  'page.relation.other': '其他',
  'editModal.title': '修改命主資料',
  'editModal.addProfile': '新增檔案',
  'editModal.name': '姓名',
  'editModal.namePlaceholder': '請輸入姓名',
  'editModal.gender': '性別',
  'editModal.male': '男',
  'editModal.female': '女',
  'editModal.birthTime': '出生時間',
  'editModal.required': '必填',
  'editModal.pleaseSelect': '請選擇',
  'editModal.birthPlace': '出生地區',
  'editModal.group': '分組',
  'editModal.trueSolarTime': '真太陽時：',
  'editModal.coordinates': '地址經緯：',
  'editModal.saveLabel': '保存',
  'editModal.saveAndChart': '保存並排盤',
  'editModal.chartOnly': '僅本次排盤',
  'editModal.saveToggleLabel': '儲存至檔案',
  'editModal.saveToggleOn': '開啟後修改將儲存至檔案',
  'editModal.saveToggleOff': '關閉後修改僅本次有效，不入庫',
  'basicInfo.instantChart': '即時局',
  'basicInfo.field.name': '姓名',
  'basicInfo.field.gender': '性別',
  'basicInfo.field.lunar': '農曆',
  'basicInfo.field.zodiac': '生肖',
  'basicInfo.field.solar': '陽曆',
  'basicInfo.field.trueSolar': '真太陽時',
  'basicInfo.field.birthPlace': '出生地域',
  'basicInfo.field.renYuan': '人元司令分野',
  'basicInfo.field.jieQi': '出生節氣',
  'basicInfo.field.jieTai': '節胎',
  'basicInfo.field.qingMing': '清明',
  'basicInfo.field.zodiacSign': '星座生位',
  'basicInfo.field.constellation': '星宿',
  'basicInfo.field.kongWang': '空亡',
  'basicInfo.field.taiYuan': '胎元',
  'basicInfo.field.taiXi': '胎息',
  'basicInfo.field.mingGua': '命卦',
  'basicInfo.field.mingGong': '命宮',
  'basicInfo.field.shenGong': '身宮',
  'basicInfo.assist.title': '輔助參考',
  'basicInfo.assist.dayMasterXi': '日主屬性',
  'basicInfo.assist.yangYin': '陽陰參考',
  'basicInfo.assist.wangShuai': '旺衰參考',
  'basicInfo.assist.geJu': '格局參考',
  'basicInfo.compositeChart.title': '天時命卦綜合盤',
  'basicInfo.birthChart.title': '出生天體圖',
  'basicInfo.birthChart.desc': '出生天體圖以真太陽時、節氣、二十八宿與四柱輔助宮位定位命局天時，用於輔助判斷月令、旺衰、空亡與格局。',
  'basicInfo.birthAstronomy.title': '出生天體圖',
  'basicInfo.birthAstronomy.note': '註：採用現代天文觀測法，日月星辰軌跡按逆時針方向運動',
  'basicPaipan.col.date': '日期',
  'basicPaipan.col.mainStar': '主星',
  'basicPaipan.col.tianGan': '天干',
  'basicPaipan.col.diZhi': '地支',
  'basicPaipan.col.cangGan': '藏干',
  'basicPaipan.col.xingYun': '星運',
  'basicPaipan.col.ziZuo': '自坐',
  'basicPaipan.col.kongWang': '空亡',
  'basicPaipan.col.naYin': '納音',
  'basicPaipan.col.shenSha': '神煞',
  'basicPaipan.mingGong': '命宮',
  'basicPaipan.qiYun': '起運：',
  'basicPaipan.jiaoYun': '交運：',
  'basicPaipan.ageSuffix': '歲',
  'basicPaipan.siLingPrefix': '司令：',
  'basicPaipan.daYunTitle': '大運',
  'basicPaipan.xiaoYun': '小運',
  'basicPaipan.liuNianTitle': '流年',
  'basicPaipan.yearCol': '年份',
  'basicPaipan.xiaoYunCol': '小運',
  'professionalPaipan.title': '專業細盤',
  'professionalPaipan.calculating': '專業細盤計算中...',
  'professionalPaipan.fourPillarDetail': '四柱專業細盤',
  'professionalPaipan.liunianColumn': '流年',
  'professionalPaipan.dayunColumn': '大運',
  'professionalPaipan.hiddenAndSub': '藏干',
  'professionalPaipan.natalShensha': '四柱神煞',
  'professionalPaipan.currentDayunShensha': '當前大運神煞',
  'professionalPaipan.currentLiunianShensha': '當前流年神煞',
  'professionalPaipan.noTransitShensha': '此運柱暫無重點神煞落點',
  'professionalPaipan.resolveTitle': '調和參考',
  'professionalPaipan.relationTitle': '大運流年聯動規則',
  'professionalPaipan.noteTitle': '專業排盤說明',
  'professionalPaipan.ruleDesc': '大運神煞與流年神煞按同一套命局神煞規則計算：將大運/流年干支視作外來運柱，只取落在運柱上的神煞；流年再與當前大運做同星疊見、合沖害破關係判斷，用於識別本年被觸發的重點象意。',
  'professionalPaipan.dayunList': '大運神煞表',
  'professionalPaipan.liunianList': '流年神煞表',
  'professionalPaipan.transitShenshaList': '大運流年神煞表',
  'professionalPaipan.current': '當前',
  'professionalPaipan.selected': '已選',
  'professionalPaipan.pillar.年柱': '年柱',
  'professionalPaipan.pillar.月柱': '月柱',
  'professionalPaipan.pillar.日柱': '日柱',
  'professionalPaipan.pillar.时柱': '時柱',
  'paipanRisk.notice': '八字排盤為傳統命理文化，當前內容資訊僅供娛樂使用，不等於專業測評，不代表價值評判，無任何現實指導意義，僅供娛樂參考。',
  'proPaipan.sec.mingJu': '命局分析',
  'proPaipan.sec.xingChong': '刑沖合害',
  'proPaipan.sec.shenSha': '神煞詳解',
  'proPaipan.sec.daYun': '大運流年',
  'proPaipan.yongShen.title': '用神分析',
  'proPaipan.yongShen.label0': '用神',
  'proPaipan.yongShen.value0': '壬水',
  'proPaipan.yongShen.desc0': '調候用神，平衡火旺',
  'proPaipan.yongShen.label1': '喜神',
  'proPaipan.yongShen.value1': '金水',
  'proPaipan.yongShen.desc1': '生扶用神，助力運勢',
  'proPaipan.yongShen.label2': '忌神',
  'proPaipan.yongShen.value2': '木火',
  'proPaipan.yongShen.desc2': '克泄用神，需防克制',
  'proPaipan.yongShen.label3': '仇神',
  'proPaipan.yongShen.value3': '土',
  'proPaipan.yongShen.desc3': '幫扶忌神，運勢受阻',
  'proPaipan.yongShen.analysis': '此命局日主丙火生于酉月，火氣漸衰，月令為金，官星當令。命局火旺，需壬水調候，以金水為喜用，木火為忌仇。行金水運時事業財運順遂，行木火運時需防波折。',
  'proPaipan.geJu.title': '格局判斷',
  'proPaipan.geJu.name': '正官格',
  'proPaipan.geJu.sub1': '月令酉金，癸水透干',
  'proPaipan.geJu.sub2': '官星有力，格局清純',
  'proPaipan.geJu.desc': '正官格主人品端正，做事有原則，適合從事管理、行政、法律等職業。官星得令，事業運較強，中年後有晉升機會。',
  'proPaipan.auspicious': '吉',
  'proPaipan.inauspicious': '凶',
  'proPaipan.xingChong.0.type': '三合',
  'proPaipan.xingChong.0.pillars': '午·戌·寅',
  'proPaipan.xingChong.0.desc': '火局三合，旺火助身，利事業發展',
  'proPaipan.xingChong.1.type': '六合',
  'proPaipan.xingChong.1.pillars': '子·丑',
  'proPaipan.xingChong.1.desc': '子丑合土，財星入庫，利財運',
  'proPaipan.xingChong.2.type': '相沖',
  'proPaipan.xingChong.2.pillars': '子·午',
  'proPaipan.xingChong.2.desc': '子午相沖，水火不容，情緒波動較大',
  'proPaipan.xingChong.3.type': '相刑',
  'proPaipan.xingChong.3.pillars': '酉·戌',
  'proPaipan.xingChong.3.desc': '酉戌相刑，無恩之刑，需防官非',
  'proPaipan.xingChong.4.type': '相害',
  'proPaipan.xingChong.4.pillars': '卯·辰',
  'proPaipan.xingChong.4.desc': '卯辰相害，六害之一，人際關係需注意',
  'proPaipan.shenSha.0.name': '天乙貴人',
  'proPaipan.shenSha.0.pillar': '月柱·時柱',
  'proPaipan.shenSha.0.desc': '逢凶化吉，貴人相助，一生多得貴人提携',
  'proPaipan.shenSha.0.type': 'auspicious',
  'proPaipan.shenSha.1.name': '天德貴人',
  'proPaipan.shenSha.1.pillar': '年柱',
  'proPaipan.shenSha.1.desc': '舒緩不順，逢難呈祥，官場順遂',
  'proPaipan.shenSha.1.type': 'auspicious',
  'proPaipan.shenSha.2.name': '月德貴人',
  'proPaipan.shenSha.2.pillar': '日柱',
  'proPaipan.shenSha.2.desc': '德澤深厚，心地善良，多得陰德庇護',
  'proPaipan.shenSha.2.type': 'auspicious',
  'proPaipan.shenSha.3.name': '福星貴人',
  'proPaipan.shenSha.3.pillar': '時柱',
  'proPaipan.shenSha.3.desc': '福祿綿延，財運亨通，晚年尤佳',
  'proPaipan.shenSha.3.type': 'auspicious',
  'proPaipan.shenSha.4.name': '德秀貴人',
  'proPaipan.shenSha.4.pillar': '日柱',
  'proPaipan.shenSha.4.desc': '才華出眾，品德高尚，文藝方面有天賦',
  'proPaipan.shenSha.4.type': 'auspicious',
  'proPaipan.shenSha.5.name': '劫煞',
  'proPaipan.shenSha.5.pillar': '年柱',
  'proPaipan.shenSha.5.desc': '易遭劫難，需防小人，出行宜謹慎',
  'proPaipan.shenSha.5.type': 'inauspicious',
  'proPaipan.shenSha.6.name': '亡神',
  'proPaipan.shenSha.6.pillar': '月柱',
  'proPaipan.shenSha.6.desc': '主破財損耗，需防意外損失',
  'proPaipan.shenSha.6.type': 'inauspicious',
  'proPaipan.daYunHeader': '大運 壬申',
  'proPaipan.daYunRange': '2018~2028 · 30~40歲',
  'proPaipan.liunian.title': '2026年流年簡析',
  'proPaipan.liunian.name': '比肩·劫財年',
  'proPaipan.liunian.sub': '天干丙火比肩，地支午火劫財',
  'proPaipan.liunian.desc': '2026年丙午年，比劫旺盛，競爭激烈，財運受損，需防破財。感情方面易有波折，需謹慎處理人際關係。事業上競爭壓力較大，宜守不宜攻。',
  'basicPaipan.qiYunText': '出生後8年2月3天6時起運',
  'basicPaipan.jiaoYunText': '逢癸、癸年 立春後27天 交大運',
  'bazi.比肩': '比肩', 'bazi.劫财': '劫財', 'bazi.食神': '食神', 'bazi.伤官': '傷官',
  'bazi.偏财': '偏財', 'bazi.正财': '正財', 'bazi.七杀': '七殺', 'bazi.正官': '正官',
  'bazi.偏印': '偏印', 'bazi.正印': '正印',
  'bazi.比': '比', 'bazi.劫': '劫', 'bazi.食': '食', 'bazi.伤': '傷',
  'bazi.才': '才', 'bazi.财': '財', 'bazi.杀': '殺', 'bazi.官': '官', 'bazi.枭': '梟', 'bazi.印': '印',
  'bazi.长生': '長生', 'bazi.沐浴': '沐浴', 'bazi.冠带': '冠帶', 'bazi.临官': '臨官',
  'bazi.帝旺': '帝旺', 'bazi.衰': '衰', 'bazi.病': '病', 'bazi.死': '死',
  'bazi.墓': '墓', 'bazi.绝': '絕', 'bazi.胎': '胎', 'bazi.养': '養',
  'bazi.天河水': '天河水',   'bazi.洞下水': '洞下水',
   'bazi.露雾火': '露霧火', 'bazi.天上火': '天上火',
  'bazi.海中金': '海中金', 'bazi.炉中火': '爐中火', 'bazi.大林木': '大林木',
  'bazi.路旁土': '路旁土', 'bazi.剑锋金': '劍鋒金', 'bazi.山头火': '山頭火',
  'bazi.涧下水': '澗下水', 'bazi.城头土': '城頭土', 'bazi.白蜡金': '白蠟金',
  'bazi.杨柳木': '楊柳木', 'bazi.泉中水': '泉中水', 'bazi.屋上土': '屋上土',
  'bazi.霹雳火': '霹靂火', 'bazi.松柏木': '松柏木', 'bazi.长流水': '長流水',
  'bazi.沙中金': '沙中金', 'bazi.山下火': '山下火', 'bazi.平地木': '平地木',
  'bazi.壁上土': '壁上土', 'bazi.金箔金': '金箔金', 'bazi.覆灯火': '覆燈火',
  'bazi.大驿土': '大驛土', 'bazi.钗钏金': '釵釧金', 'bazi.桑柘木': '桑柘木',
  'bazi.大溪水': '大溪水', 'bazi.沙中土': '沙中土',
  'bazi.石榴木': '石榴木', 'bazi.大海水': '大海水',
  'xiaoyun.title': '小運',
  'xiaoyun.subtitle': '每年一換',
  'xiaoyun.currentLabel': '當前',
  'xiaoyun.expandHint': '點擊展開',
  'xiaoyun.infoText': '小運每年一換，是大運的細化補充，反映每一年的具體運勢走向。',
  'xiaoyun.listTitle': '小運',
  'xiaoyun.stemLabel': '干',
  'xiaoyun.branchLabel': '支',
  'xiaoyun.noShensha': '命局神煞較少，運勢平穩',
  'xiaoyun.shenshaTitle': '命局神煞',
  'basicPaipan.yuelingTitle': '月令五行用事',
  'basicPaipan.yueling.fenyeTitle': '人元司令分野',
  'basicPaipan.yueling.totalDays': '共{{totalDays}}天',
  'basicPaipan.yueling.current': '當前',
  'basicPaipan.yueling.detailTitle': '詳解',
  'basicPaipan.yueling.personality': '性格',
  'basicPaipan.yueling.career': '事業',
  'basicPaipan.yueling.emotion': '感情',
  'basicPaipan.yueling.health': '健康',
  'basicPaipan.yueling.advice': '建議',
  'proPaipan.share.title': '命局分析分享卡片',
  'proPaipan.share.hint': '把五行、日主、用神、格局合成精美分享圖',
  'proPaipan.share.saveImage': '保存圖片',
  'proPaipan.share.shareToFriend': '分享給好友',
  'proPaipan.share.selectPlatform': '選擇分享平台',
  'bazi.德秀贵人': '德秀貴人', 'bazi.天乙贵人': '天乙貴人', 'bazi.天德贵人': '天德貴人', 'bazi.福星贵人': '福星貴人',
  'bazi.jieQi.0': '立春', 'bazi.jieQi.1': '驚蟄', 'bazi.jieQi.2': '清明', 'bazi.jieQi.3': '立夏',
  'bazi.jieQi.4': '芒種', 'bazi.jieQi.5': '小暑', 'bazi.jieQi.6': '立秋', 'bazi.jieQi.7': '白露',
  'bazi.jieQi.8': '寒露', 'bazi.jieQi.9': '立冬', 'bazi.jieQi.10': '大雪', 'bazi.jieQi.11': '小寒',
};

export default paipan;
